import { AppBar, Toolbar, IconButton, Typography, createTheme, ThemeProvider } from '@mui/material';
import PoolIcon from '@mui/icons-material/Pool';
import './App.css';
import AthleteSearchPage from "./search/AthleteSearchPage";
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
    
ModuleRegistry.registerModules([ AllCommunityModule ]);


const theme = createTheme({
  palette: {
    primary: {
      main: "#05aad8"
    },
    secondary: {
      main: "#b4e5f4"
    }
  }
});

function App() {

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <AppBar position="static" sx={{
              marginBottom: '20px',
            }}>
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2, color: 'white' }}
              href="/"
            >
              <PoolIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1, color: 'white', paddingRight: '40px' }}>
              STANDARDS NATATION CANADA
            </Typography>            
          </Toolbar>
        </AppBar>  
            
        <AthleteSearchPage />
      </ThemeProvider>
      
    </div>
  );
}

export default App;
